export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: "menuitems.dashboard.text",
        link: "/",
        icon: "bx-home-circle",
    },

    {
        id: 5,
        label: "menuitems.patients.text",
        link: "/patients",
        icon: "bxs-user-rectangle",
    },

    {
        id: 8,
        label: "menuitems.consultations.text",
        link: "",
        icon: "bxs-calendar-event",

        subItems: [
            {
                id: 41,
                label: "menuitems.consultations.text",
                link: "/consultations",
                parentId: 8
            },
            {
                id: 42,
                label: "menuitems.consultations.list.cancelled_consultations",
                link: "/consultations/cancelled",
                parentId: 8
            },
        ]

    },

    {
        id: 32,
        label: "menuitems.chat.text",
        link: "/chat",
        icon: "bx-chat",
    },

    {
        id: 14,
        label: "menuitems.pharmacy.text",
        link: "",
        icon: "bxs-capsule",

        subItems: [
            {
                id: 15,
                label: "menuitems.pharmacy.list.orders",
                link: "/pharmacy-orders",
                parentId: 14
            },
            {
                id: 16,
                label: "menuitems.pharmacy.list.requests",
                link: "/pharmacy-requests",
                parentId: 14
            },
            {
                id: 53,
                label: "menuitems.pharmacy.list.pharmacies",
                link: "/pharmacies",
                parentId: 14
            },
        ]
    },


    {
        id: 9,
        label: "menuitems.doctors.text",
        link: "",
        icon: "bx-plus-medical",

        subItems: [
            {
                id: 10,
                label: "menuitems.doctors.list.pending",
                link: "/doctors/pending",
                parentId: 9
            },
            {
                id: 12,
                label: "menuitems.doctors.list.rejected",
                link: "/doctors/rejected",
                parentId: 9
            },
            {
                id: 11,
                label: "menuitems.doctors.list.approved",
                link: "/doctors",
                parentId: 9
            },
            {
                id: 46,
                label: "menuitems.doctors.list.schedule-requests",
                link: "/doctors/schedule-requests",
                parentId: 9
            },
        ]
    },
    {
        id: 22,
        label: "menuitems.clinics.text",
        link: "/clinics",
        icon: "bx-clinic",
    },
    {
        id: 26,
        label: "menuitems.tokens.text",
        link: "/tokencalls",
        icon: "bx-user-voice",
    },

    {
        id: 33,
        label: "menuitems.labs.text",
        link: "/labs",
        icon: "bx-clinic",

        subItems: [
            {
                id: 34,
                label: "menuitems.labs.list.labs",
                link: "/labs",
                parentId: 33
            },
            {
                id: 35,
                label: "menuitems.labs.list.tests",
                link: "/tests",
                parentId: 33
            },

        ]
    },
    {
        id: 36,
        label: "menuitems.reports.text",
        link: "",
        icon: "bxs-calendar-event",

        subItems: [
            {
                id: 37,
                label: "menuitems.reports.list.consultations",
                link: "/reports/consultations",
                parentId: 36
            },
            {
                id: 52,
                label: "menuitems.reports.list.invoices",
                link: "/reports/invoices",
                parentId: 36
            },

            {
                id: 38,
                label: "menuitems.reports.list.earnings",
                link: "/reports/earnings",
                parentId: 36
            },
            {
                id: 39,
                label: "menuitems.reports.list.patients",
                link: "/reports/patients",
                parentId: 36
            },
            {
                id: 40,
                label: "menuitems.reports.list.marketingstaffs",
                link: "/reports/marketing-staffs",
                parentId: 36
            },
            {
                id: 44,
                label: "menuitems.reports.list.tv_show",
                link: "/reports/tv_show",
                parentId: 36
            },
            {
                id: 45,
                label: "menuitems.reports.list.scrolling_contents",
                link: "/reports/scrolling_contents",
                parentId: 36
            },
        ]
    },


    {
        id: 29,
        label: "menuitems.payments.text",
        link: "",
        icon: "bx-money",

        subItems: [
            {
                id: 30,
                label: "menuitems.payments.list.pending",
                link: "/doctor-payments/pending",
                parentId: 29
            },
            {
                id: 31,
                label: "menuitems.payments.list.completed",
                link: "/doctor-payments/completed",
                parentId: 29
            },

        ]
    },

   

    {
        id: 18,
        label: "menuitems.coupons.text",
        link: "/coupons",
        icon: "bxs-coupon",
    },


    {
        id: 13,
        label: "menuitems.specializations.text",
        link: "/specializations",
        icon: "bx-book",
    },

    {
        id: 19,
        label: "menuitems.languages.text",
        link: "/languages",
        icon: "bx-user-voice",
    },

    {
        id: 17,
        label: "menuitems.sliders.text",
        link: "/sliders",
        icon: "bx-slider-alt",
    },

    {
        id: 31,
        label: "menuitems.banners.text",
        link: "/banners",
        icon: "bx-slider-alt",
    },

   

    {
        id: 20,
        label: "menuitems.deliverystaffs.text",
        link: "/delivery-staffs",
        icon: "bxs-cart",
    },

    {
        id: 21,
        label: "menuitems.marketingstaffs.text",
        link: "/marketing-staffs",
        icon: "bx-briefcase",
    },

    {
        id: 43,
        label: "menuitems.agencies.text",
        link: "/agencies",
        icon: "bx-video-plus",
    },
    {
        id: 23,
        label: "menuitems.tvshows.text",
        link: "/tvshows",
        icon: "bx-tv",
    },

   

    {
        id: 24,
        label: "menuitems.scrollcontents.text",
        link: "/scroll-contents",
        icon: "bx-book-content",
    },

    {
        id: 25,
        label: "menuitems.feedbacks.text",
        link: "/feedbacks",
        icon: "bx-message-dots",
    },


    {
        id: 54,
        label: "menuitems.relations.text",
        link: "/member-relations",
        icon: "bxs-user-rectangle",
    },

    {
        id: 27,
        label: "menuitems.notifications.text",
        link: "/notifications",
        icon: "bx-bell",
    },

    {
        id: 30,
        label: "menuitems.pincodes.text",
        link: "/pincodes",
        icon: "bx-map-pin",
    },
    {
        id: 47,
        label: "menuitems.cms.text",
        icon: "bx-book-content",

        subItems: [
            {
                id: 48,
                label: "menuitems.cms.list.about",
                link: "/cms/about",
                parentId: 47
            },
            {
                id: 49,
                label: "menuitems.cms.list.terms",
                link: "/cms/terms",
                parentId: 47
            },
            {
                id: 50,
                label: "menuitems.cms.list.privacy",
                link: "/cms/privacy-policy",
                parentId: 47
            },
            {
                id: 51,
                label: "menuitems.faqs.text",
                link: "/faqs",
                parentId: 47
            },

        ]
    },

    {
        id: 28,
        label: "menuitems.settings.text",
        link: "/settings",
        icon: "bx-cog",
    },
];

